import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card } from 'react-bootstrap';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Flex from '../../common/Flex';
import AppContext from '../../context/Context';

function InboxFooter({
  totalItems,
  from,
  to,
  canNextPage,
  canPreviousPage,
  nextPage,
  prevPage,
}) {
  const {
    config: { isRTL },
  } = useContext(AppContext);

  return (
    <Card.Footer as={Flex} justifyContent="between" alignItems="center">
      <div>
        <small>
          {from}
          -
          {to}
          {' '}
          of
          {totalItems}
        </small>
        <Button
          variant="falcon-default"
          size="sm"
          className="ms-1 ms-sm-2"
          disabled={!canPreviousPage}
          onClick={prevPage}
        >
          <FontAwesomeIcon icon={isRTL ? faChevronRight : faChevronLeft} />
        </Button>
        <Button
          variant="falcon-default"
          size="sm"
          className="ms-1 ms-sm-2"
          disabled={!canNextPage}
          onClick={nextPage}
        >
          <FontAwesomeIcon icon={isRTL ? faChevronLeft : faChevronRight} />
        </Button>
      </div>
    </Card.Footer>
  );
}

InboxFooter.propTypes = {
  totalItems: PropTypes.number.isRequired,
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  canPreviousPage: PropTypes.bool.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
};

export default InboxFooter;
